import { CommonStatusType } from "src/app/globals/custom-types/global-custom-types";
import { ILimitSkipSort } from "src/app/globals/globals";
import { LocaleType } from "../../locale/models/locale";
import { MapType } from "../enum/map-type";
import { MapMarkerInfo } from "./map-marker-info";

export class ICustomMap {
    _id: string;
    accessLevel: number;
    distance: number
    isPrivate: boolean
    localeId: LocaleType
    mapType: MapType
    name: string;
    origin: google.maps.LatLngLiteral
    status: CommonStatusType;

    constructor(){
    }
}


export class ManualMap extends ICustomMap{    
    markers: MapMarkerInfo[]
    formattedAddress: string

    constructor(){
        super()
        this.mapType = MapType.MANUAL
        this.markers = []
    }
}

export class AutoMap extends ICustomMap{
    destination: google.maps.LatLngLiteral
    startLocation: string
    endLocation: string
    
    constructor(){
        super()
        this.mapType = MapType.AUTO
    }
}

export type CustomMap = ManualMap | AutoMap

export type CustomMapQuery = (Partial<AutoMap> | Partial<ManualMap>) & ILimitSkipSort

